/* eslint-disable @typescript-eslint/interface-name-prefix */
import { InjectionToken } from '@angular/core';

export class BaseFilterRequest {
    pageNo = 1;
    itemsPerPage = 25;
    search = '';
    s?: string;
    sortOrder?: 'asc' | 'desc' = 'desc';
    sortBy?: string;
    filterBy: string;
    totalPageCount: number;
    ui_view?: boolean | number;
    is_ai_query?: boolean;
}

export class MessageData {
    public type: 'Error' | 'Info';
    public title: string;
    public message: string;
}

export type errorType = string[] | string | { [key: string]: [] };

export class BaseResponse<T, TRequest> {
    public data: T;
    public status: 'success' | 'fail' | 'ERROR' | 'SUCCESS';
    public hasError?: boolean;
    public errors?: errorType;
    public request?: TRequest;
    public queryString?: any;
    public error?: any;
    public message?: any;
}

export interface IPaginatedResponse<P> {
    data: P;
    itemsPerPage: number;
    pageNumber: number;
    pageNo?: number;
    totalEntityCount: number;
    totalEntityCountWithoutFilter?: number;
    totalPageCount: number; // Total records of p in database without applying filters
    is_active?: boolean;
}

export interface IIdNameModel {
    id: number;
    name: string;
}

export interface IPaginatedEmailResponse<P> {
    data: P;
    current_page: number;
    first_page_url: string;
    from: number;
    last_page: number;
    last_page_url: string;
    next_page_url: string;
    path: string;
    per_page: string;
    prev_page_url: null | string;
    to: number;
    total: number;
}

export enum ProxyBaseUrls {
    EmailProxy = 'EMAIL_BASE_URL',
    RcsProxy = 'RCS_BASE_URL',
    MsgProxy = 'MSG_PROXY_BASE_URL',
    HelloProxy = 'HELLO_BASE_URL',
    WhatsAppProxy = 'WHATS_APP_BASE_URL',
    CampaignProxy = 'CAMPAIGN_BASE_URL',
    OneApiProxy = 'ONE_API_BASE_URL',
    SubscriptionProxy = 'SUBSCRIPTION_BASE_URL',
    ShortURLProxy = 'SHORT_URL_BASE_URL',
    SubscriptionURLProxy = 'SUBSCRIPTION_URL_BASE_URL',
    BaseURL = 'BASE_URL',
    BaseServer = 'BASE_SERVER',
    ProxyURL = 'PROXY_URL',
    FirebaseConfig = 'FIREBASE_CONFIG',
    AdminServer = 'ADMIN_SERVER',
    AdminProxy = 'ADMIN_PROXY',
    VoiceBaseURL = 'VOICE_BASE_URL',
    EmailServerURL = 'EMAIL_SERVER_URL',
    SegmentoBaseURL = 'SEGMENTO_BASE_URL',
    InvisibleOtpBaseURL = 'INVISIBLE_OTP_BASE_URL',
    SegmentoV1BaseURL = 'SEGMENTO_V1_BASE_URL',
    HelloBaseURL = 'HELLO_API_URL',
    Env = 'ENV',
    IToken = 'IToken',
    ReportsUrl = 'REPORTS_URL',
    FileUploadProxy = 'FILE_UPLOAD_PROXY',
    NumbersProxy = 'NUMBERS_PROXY',
    InvisibleOTPProxy = 'INVISIBLE_OTP_PROXY',
    PushNotificationProxy = 'PUSH_NOTIFICATION_URL',
    EnableMsg91Proxy = 'ENABLE_MSG91_PROXY',
    SegmentoMsg91BasePath = 'SEGMENTO_MSG91_BASE_PATH',
    ViasocketBaseUrl = 'VIASOCKET_BASE_URL',
    AddProxyAppHashInApiCall = 'ADD_PROXY_APP_HASH_IN_API_CALL',
    SocketBaseUrl = 'SOCKET_BASE_URL',
    BasePath = 'BASEPATH',
    ShowViaSocketFlows = 'SHOW_VIA_SOCKET_FLOWS',
    ViaSocketOriginUrl = 'VIA_SOCKET_ORIGIN_URL',
    EnableHelloNewSocketSubscription = 'ENABLE_HELLO_NEW_SOCKET_SUBSCRIPTION',
    ProdServer = 'PROD_SERVER',
    HelloBotExampleApi = 'HELLO_BOT_EXAMPLE_API',
    HelloBotPromptApi = 'HELLO_BOT_PROMPT_API',
    HelloBotAndCompanyIdApi = 'HELLO_BOT_AND_COMPANY_ID_API',
    HelloDefaultMessage = 'HELLO_DEFAULT_MESSAGE',
    ViaSocketProjectId = 'VIA_SOCKET_PROJECT_ID',
    EncryptionKeyOfCrypto = 'ENCRYPTION_KEY_OF_CRYPTO',
    Msg91HelloMailNewUI = 'MSG91_HELLO_MAIL_NEW_UI',
    FroalaKeyV3 = 'FROALA_KEY_V3',
    ChannelAlert = 'CHANNEL_ALERT',
    SocketUrl = 'SOCKET_URL',
    EmailOutlookClientId = 'EMAIL_OUTLOOK_CLIENT_ID',
    EmailOutlookScope = 'EMAIL_OUTLOOK_SCOPE',
    GmailInboxClientId = 'GMAIL_INBOX_CLIENT_ID',
    Msg91InstagramAuthUrl = 'MSG91_INSTAGRAM_AUTH_URL',
    DisableKycChecksForInrCountries = 'DISABLE_KYC_CHECKS_FOR_INR_COUNTRIES',
    PaymentUri = 'PAYMENT_URI',
    EnableNewSubscriptionDesign = 'ENABLE_NEW_SUBSCRIPTION_DESIGN',
    WhatsAppEmbededAppId = 'WHATS_APP_EMBEDED_APP_ID',
    HelloElectronApp = 'HELLO_ELECTRON_APP',
    TechDocSsoUrl = 'TECH_DOC_SSO_URL',
    ViasocketSsoUrl = 'VIA_SOCKET_SSO_URL',
    EmailGoogleClientId = 'EMAIL_GOOGLE_CLIENT_ID',
    EmailGoogleScope = 'EMAIL_GOOGLE_SCOPE',
    EmailGoogleScopeAllowedCompanyId = 'EMAIL_GOOGLE_SCOPE_ALLOWED_COMPANY_ID',
    SegmentoSubscriptionDisabled = 'SEGMENTO_SUBSCRIPTION_DISABLED',
}

export const HelloBaseUrlToken = new InjectionToken<string>('HELLO_API_URL');
export const BotBaseUrlToken = new InjectionToken<string>('BOT_API_URL');
export const KbPublishUrl = new InjectionToken<string>('KB_PUBLISH_URL');
export const KbProxyUrl = new InjectionToken<string>('KB_PROXY_URL');
export const Msg91AgenticAiChatbotUrl = new InjectionToken<string>('MSG91_AGENIC_AI_CHATBOT_URL');

export interface IToken {
    proxyJWTToken: string;
    token: string;
    companyId: string;
    billing_country_shortname: string | null;
}

export class BaseEmailFilterRequest {
    page? = 1;
    per_page? = 25;
    search_in?: string;
    keyword?: string;
    order_type?: 'asc' | 'desc' = 'desc';
    order_by?: string;
}

export interface ILineGraphData {
    name: string;
    series: ILineGraphSeries[];
}

export interface ILineGraphSeries {
    value: number;
    name: number | Date;
}

export interface IPaginationAnalyticsResponse {
    page: number;
    pageSize: number;
    total?: number;
}

export interface keyValuePair<T> {
    [key: string]: T;
}

export class MicroserviceBaseResponse<T, TRequest> extends BaseResponse<T, TRequest> {
    success: boolean;
    message: string[] | string | { [key: string]: [] };
}

export type MappedTypeWithOptional<Type> = {
    [Properties in keyof Type]?: Type[Properties];
};

export interface IGetClientResModule {
    user_pid: string;
    user_name: string;
    user_fname: string;
    user_lname: string;
    user_uname: string;
    user_mobno: string;
    user_email: string;
    user_type: string;
    user_rid: string;
    user_expiry: string;
    user_status: string;
    user_date: string;
    signup_date: string;
    userPanelId: string;
    user_currency: string;
    userWalletEnabled: number;
}

export interface IFirebaseUserModel {
    uid: string;
    displayName: string;
    email: string;
    phoneNumber: string;
    photoURL: string;
    emailVerified: boolean;
    jwtToken: string;
}

export function errorResolver(params: string[] | string | { [key: string]: [] }): string[] {
    if (typeof params === 'string') {
        return [params];
    } else if (params instanceof Array) {
        return params;
    } else if (params instanceof Object) {
        return [].concat(
            ...Object.keys(params).map((p) => {
                return params[p];
            })
        );
    } else {
        return ['Something went wrong.'];
    }
}

export function fetchFirstErrorRecursively(errObj: { [key: string]: any }): any {
    if (errObj && typeof errObj === 'object') {
        return fetchFirstErrorRecursively(errObj[Object.keys(errObj)[0]]);
    } else {
        return errObj;
    }
}

export interface ISharedWebhookList {
    key: string;
    name: string;
}

export interface ICommondsObjectState {
    command_name: string;
    command_description: string;
}

export interface INumberSettingsData {
    integrated_number: number | null;
    enable_welcome_message: boolean;
    commands: ICommondsObjectState[];
    prompts: string[];
}

export interface IWhatsAppNumberSettingsStates {
    isLoading: boolean;
    isDataUpdating: boolean;
    isDataUpdated: boolean;
    numberSettingsData: INumberSettingsData;
}

export enum ChannelTypeEnums {
    Email = '3',
    Voice = '4',
    SMS = '11',
    Whatsapp = '12',
    Instagram = '6',
    Facebook = '7',
    Telegram = '8',
    Rcs = '9',
}

export enum PurposeType {
    MarketingAndPromtion = '1',
    TransactionalAndCommunication = '2',
    AIDrivenCustomer = '3',
    OTP = '4',
    Api = '5',
    Other = '6',
}

export enum ToolsType {
    Hello = '1',
    Segmento = '2',
    Campaign = '3',
    Otp = '4',
}

export interface ICallSettings {
    status: 'ENABLED' | 'DISABLED';
    call_icon_visibility: 'DEFAULT' | string;
    callback_permission_status: 'NOT_SET' | 'ENABLED' | 'DISABLED';
    sip: ISipSettings;
}

export interface ICallHours {
    status: 'ENABLED' | 'DISABLED';
    timezone_id: string;
    weekly_operating_hours: IWeeklyOperatingHour[];
    holiday_schedule: IHolidaySchedule[];
}

export interface IWeeklyOperatingHour {
    day_of_week: 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY';
    open_time: string;
    close_time: string;
}

export interface IHolidaySchedule {
    date: string;
    start_time: string;
    end_time: string;
}

export interface ISipSettings {
    status: 'ENABLED' | 'DISABLED';
}
